import { render, staticRenderFns } from "./drawercopy.vue?vue&type=template&id=4d5cfb0c&"
import script from "./drawercopy.vue?vue&type=script&lang=js&"
export * from "./drawercopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports